import { render, staticRenderFns } from "./EstablishmentTransferForm.vue?vue&type=template&id=dfbd93b8"
import script from "./EstablishmentTransferForm.vue?vue&type=script&lang=js"
export * from "./EstablishmentTransferForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports